import { type ICellRendererParams } from '@mint-lib/ag-grid/community';
import { Checkbox } from '@mint-lib/tw-components';

import type { SuggestionGridType } from '../../../../types/suggestion.js';
import { DefaultCell } from './DefaultCell.jsx';

const CheckboxCell = ({
  data,
  node,
  api,
}: ICellRendererParams<SuggestionGridType>) => {
  const isChannel = data?.type === 'channel';

  const selectNodes = () => {
    if (isChannel || !node.selectable) return;
    node.setSelected(!node.isSelected());
    api.refreshCells({ force: true });
  };

  return (
    <DefaultCell>
      <Checkbox
        aria-disabled={isChannel}
        onClick={selectNodes}
        checked={node.isSelected()}
        disabled={isChannel}
        aria-label={data?.name}
      />
    </DefaultCell>
  );
};
export { CheckboxCell };
